import React, { useState } from "react";

export default function CollapsibleSection({
  title,
  id,
  children,
  isExpanded = true,
  onToggle = null,
  externalControl = false,
}) {
  const [internalExpanded, setInternalExpanded] = useState(isExpanded);

  const expanded = externalControl ? isExpanded : internalExpanded;

  const handleToggle = () => {
    if (externalControl && onToggle) {
      onToggle(id);
    } else {
      setInternalExpanded(!expanded);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleToggle();
    }
  };

  return (
    <section className="section collapsible-section">
      <div
        className="section-header"
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        role="button"
        aria-expanded={expanded}
        aria-controls={`${id}-content`}
        tabIndex={0}
      >
        <h3>{title}</h3>
        <span className="toggle-icon">{expanded ? "−" : "+"}</span>
      </div>
      <div
        id={`${id}-content`}
        className={`section-content ${expanded ? "expanded" : "collapsed"}`}
      >
        {children}
      </div>
    </section>
  );
}